// Contact Model
cv.Contact = Backbone.RESTModel.extend({
  defaults: {},

  saveMap: {
    photo_path: "photo_path",
    first_name: "first_name",
    last_name: "last_name",
    email: "email",
    phone1: "phone1",

    line1: "line1",
    line2: "line2",
    city: "city",
    state: "state",
    zipcode: "zipcode",
    country: "country",
  },

  urlRoot: function () {
    return cv.api_path + "/contacts";
  },

  initialize: function () {
    console.log("Contact model initialized.");
  },
});
Cocktail.mixin(cv.Contact, cv.mixins.SyncModel);

// Contacts Collection
cv.Contacts = Backbone.Collection.extend({
  initialize: function (options) {
    console.log("Contacts collection initialized.");
  },

  url: function () {
    return cv.api_path + "/contacts?" + $.param(this.params);
  },

  model: cv.Contact,
});
Cocktail.mixin(cv.Contacts, cv.mixins.PaginateModel);

// Define the datastore
DS.defineResource({
  name: "contact",
  idAttribute: "id", // 'id' is the default
  collection: cv.Contacts,
  model: cv.Contact,
});
